import React, { ReactElement } from 'react';
import { Box, Text, Flex, Tag } from '@chakra-ui/react';
import { CarbonIconType } from '@carbon/icons-react';
import Heading from '#coreComponents/Heading';
import Card from '#coreComponents/Card';

const DashboardPageCard: React.FC<{
  title: string;
  text: string | ReactElement<{}>;
  color: string;
  icon: CarbonIconType;
  label?: string;
}> = ({ icon, title, text, color, label }) => {
  const borderLeftColor = `the.${color}`;

  return (
    <Card
      as={Flex}
      position="relative"
      overflow="hidden"
      h="100%"
      flexDirection="column"
      justifyContent="space-between"
      borderLeft="8px solid"
      borderLeftColor={borderLeftColor}
      borderRadius={0}
    >
      <Box>
        <Flex align="center" mb={3}>
          <Box as={icon} color="black" mr={2} minWidth={5} />

          <Box display="inline-flex" alignItems="center" flexWrap="wrap">
            <Heading as="h2" fontSize="xl" display="inline" mr={2}>
              {title}
            </Heading>
            {label && <Tag size="sm">{label}</Tag>}
          </Box>
        </Flex>

        <Text
          color="gray.500"
          mb={4}
          maxW={{ base: '100%', xl: '75%' }}
          fontSize="sm"
          ml={7}
        >
          {text}
        </Text>
      </Box>
    </Card>
  );
};

export default DashboardPageCard;
